import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Bell } from 'lucide-react';
import { Button, Drawer, EmptyState, SkeletonList } from '@/ui';
import { formatDateTime } from '@/features/admin/format';
import { announcementKeys, fetchAnnouncements } from './api';
import styles from './Announcements.module.css';

/**
 * ======================= DUYURULAR (ust cubuk) =============================
 *
 * `/yonetim/metrikler#duyuru` ekranindan gonderilen duyurularin OKUMA tarafi. Uc sunucuda
 * hazirdi ama web hic kullanmiyordu: gonderilen duyuruyu yalnizca mobil bildirim alanlar
 * goruyordu, web kullanicisi icin duyuru gonderilmemis sayiliyordu.
 *
 * NEDEN MENU OGESI DEGIL, UST CUBUK: duyuru bir BOLGE ekrani degil — musteri de buro da
 * gorur ve icerigi kimin hangi bolgede oldugundan bagimsiz. Menuye koymak her iki bolgenin
 * menusune ayni ogeyi eklemek (ve ucuncu bir bolge geldiginde unutmak) demekti.
 *
 * OKUNDU BILGISI YOK ve rozet de YOK: sunucu "okundu" durumu tutmuyor. Kirmizi bir sayac
 * cizmek, hicbir zaman sifirlanmayan kalici bir uyari uretirdi — okunmamis sayisi tutulmadan
 * verilen bir rozet, kullaniciyi surekli yaniltir.
 *
 * VERI SADECE ACILINCA CEKILIYOR (`enabled: open`): her sayfa yuklemesinde bir istek daha
 * atmanin karsiligi yok, duyuru nadir bir olay.
 */
export function AnnouncementsButton() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const announcements = useQuery({
    queryKey: announcementKeys.all,
    queryFn: fetchAnnouncements,
    enabled: open,
    // Duyuru nadiren degisir; cekmece her acilista agi dovmeye gerek yok.
    staleTime: 5 * 60_000,
  });

  const items = announcements.data ?? [];

  return (
    <>
      <Button
        tone="ghost"
        size="sm"
        iconLeft={<Bell size={18} aria-hidden="true" />}
        aria-label={t('announcements.open')}
        onClick={() => {
          setOpen(true);
        }}
      >
        <span className={styles.actionLabel}>{t('announcements.title')}</span>
      </Button>

      <Drawer
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        title={t('announcements.title')}
        footer={
          <Button
            tone="ghost"
            onClick={() => {
              setOpen(false);
            }}
          >
            {t('common.close')}
          </Button>
        }
      >
        {announcements.isPending ? <SkeletonList rows={3} /> : null}

        {announcements.isError ? (
          <EmptyState tone="error" title={t('announcements.loadFailed')} />
        ) : null}

        {announcements.isSuccess && items.length === 0 ? (
          <EmptyState title={t('announcements.empty')} />
        ) : null}

        {items.length > 0 ? (
          <ul className={styles.list}>
            {items.map((item) => (
              <li key={item.id} className={styles.item}>
                <p className={styles.itemTitle}>{item.title}</p>
                <p className={styles.itemBody}>{item.body}</p>
                <p className={styles.itemDate}>{formatDateTime(item.createdAt)}</p>
              </li>
            ))}
          </ul>
        ) : null}
      </Drawer>
    </>
  );
}
